import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserService} from './user.service';
import { Inject, Injectable } from '@angular/core';
import {tap} from 'rxjs/operators';
import {ToothConfigurationModel} from '../models/teeth/tooth-configuration.model';
import {DataArPaymentAuditModel} from '../modules/ar/models/data-ar-payment-audit.model';
import {ToothSurfaceConfigurationModel} from '../models/teeth/tooth-surface-configuration.model';
import {DataARClaimModel} from '../models/accountsReceivable/data-ar-claim.model';
import {ToothCanalConfigurationModel} from '../models/configuration/tooth-canal-configuration.model';
import {SignalrService} from './socket/signalr.service';
import {Globals} from '../globals';
import {FeeCodeForToothConfiguration} from "../models/teeth/fee-code-for-tooth.configuration";

@Injectable()

export class ToothService {
  static enumUnitedStatesToothGrouping = '00000091-1000-0000-0000-000000000001';
  allTeeth: ToothConfigurationModel[];

  constructor(private http: HttpClient,
              private signalrService: SignalrService,
              private globals: Globals,
              private userService: UserService) {
    //
  }

  getAllTeeth(groupingEnum: string): Observable<ToothConfigurationModel[]> {
    return this.http.get<ToothConfigurationModel[]>(`api/tooth-config/get-all-teeth/${groupingEnum}`, UserService.authorizationHeaderObject)
      .pipe(
        tap(_ => {
          this.allTeeth = _;
        })
      );
  }

  getAllToothSurfaces(): Observable<ToothSurfaceConfigurationModel[]> {
    return this.http.get<ToothSurfaceConfigurationModel[]>(`api/toothConfig/getAllToothSurfaces`);
  }

  getToothSurfacesForTooth(ToothId: string): Observable<ToothSurfaceConfigurationModel[]> {
    return this.http.get<ToothSurfaceConfigurationModel[]>(`api/toothConfig/getToothSurfacesForTooth/${ToothId}`);
  }

  saveToothCanals(canals: ToothCanalConfigurationModel[]): Observable<number> {
    return this.http.post<number>(`/api/toothConfig/save-tooth-canals`, canals);
  }

  saveToothSurfaces(surfaces: ToothSurfaceConfigurationModel[]): Observable<number> {
    return this.http.post<number>(`/api/toothConfig/save-tooth-surfaces`, surfaces);
  }

  addToothCanals(canals: ToothCanalConfigurationModel[]): Observable<ToothCanalConfigurationModel[]> {
    return this.http.post<ToothCanalConfigurationModel[]>(`/api/toothConfig/add-tooth-canals`, canals);
  }

  addToothSurfaces(surfaces: ToothSurfaceConfigurationModel[]): Observable<ToothSurfaceConfigurationModel[]> {
    return this.http.post<ToothSurfaceConfigurationModel[]>(`/api/toothConfig/add-tooth-surfaces`, surfaces);
  }

  notifyToothChange() {
    this.signalrService.messageAllUsers(SignalrService.UPDATE_TEETH, {patientId: this.globals.currentPatientId});
  }

  getFeeCodeTeeth() {
    return this.http.get<FeeCodeForToothConfiguration[]>(`api/tooth-config/get-fee-code-teeth`);
  }

  saveCodeForTeeth(selectedCodeForTeeth: FeeCodeForToothConfiguration) {
    return this.http.post<FeeCodeForToothConfiguration>(`api/tooth-config/save-code-for-teeth`, selectedCodeForTeeth);
  }

  deleteFeeCodeForTooth(model: FeeCodeForToothConfiguration) {
    return this.http.get<void>(`api/tooth-config/delete-code-for-teeth/${model.Code}`);
  }
}
